import { datalayers, defineDirective, groupBy, models, sum } from "../../omnia"

    import Datalayer = datalayers.Datalayer
import { Chart } from "chart.js"

export class TerramapDistributionCtrl {

    static create(): ng.IDirective {

        const def = defineDirective(TerramapDistributionCtrl, undefined, {
            layer: "="
        })

        def.template = `<div><canvas width="295" height="200" style="width:295px;height:200px"></canvas></div>`

        def.link = (scope, element: ng.IAugmentedJQuery, attrs, ctrl: TerramapDistributionCtrl) => ctrl.link(element)

        return def

    }


    private _rootElt: ng.IAugmentedJQuery

    private layer: Datalayer

    private chart: Chart

    static $inject = ["$scope", "OmniaDatalayersService"]

    constructor(private $scope: ng.IScope) {
    }

    $onDestroy() {
        this.chart?.destroy()
        this.chart = undefined
    }

    private link(element: ng.IAugmentedJQuery) {
        this._rootElt = element
        this.setup()
    }

    private setup() {

        if (this._rootElt) {
            this.$scope.$watch("vm.layer", () => this.setupLayer())
        }

    }

    private setupLayer() {

        if (!this.layer) {
            return
        }

        this.chart?.destroy()

        const viewer = this.layer.viewer

        const key = viewer.getKey()

        const zones = this.layer.zones.map(z => ({
            area: z.area / 10000,
            value: z.value as number,
            keyEntry: key.layerKey.find(e => e.value == z.value)
        }))

        let groups = groupBy(zones, d => d.keyEntry, e => e.value).map(g => ({
            area: Math.round(sum(g.values, v => v.area) * 10) / 10,
            keyEntry: g.key,
            label: g.key.text?.replace(" - ", "-"),
            value: g.key.value
        }))

        groups = groups.sort((a, b) => a.value - b.value)

        const labels = []
        const data = []
        const colours = []

        const totalArea = sum(groups, d => d.area)

        const textLength = sum(groups, g => (g.label || "").length)
        const small = textLength > 40

        groups.forEach(d => {
            data.push(Math.round((d.area / totalArea) * 100))
            labels.push({
                label: small ? d.value : d.label,
                tooltip: d.label
            })
            colours.push(omnia.color.colorToCss(d.keyEntry.color))
        })

        const ctx = (this._rootElt[0].querySelector("canvas") as HTMLCanvasElement).getContext("2d")

        this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels.map(l => l.label),
                datasets: [{
                    data: data,
                    backgroundColor: colours,
                    label: this.layer.type.Name,
                    borderColor: 'lightgray',
                    borderWidth: 1
                }]
            },
            options: {
                title: {
                    display: true,
                    text: `${this.layer.type.Name}: distribution by area`
                },
                tooltips: {
                    enabled: true,
                    callbacks: {
                        title: () => undefined,
                        label: item => labels[item.index]?.tooltip + " t/ha"
                    }
                },
                legend: {
                    display: false,
                    labels: {
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                    }
                },
                responsive: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            callback: (value) => {
                                return value + '%'
                            }
                        }
                    }],
                    xAxes: [{
                        afterCalculateTickRotation: a => {
                            a.labelRotation = 0
                        },
                        ticks: {
                            callback: (_, index) => [
                                labels[index]?.label,
                                groups[index].area + " ha"
                            ] as any
                        }
                    }]
                }
            }
        })

    }

}
